const siteConfig = {
  brandName: "reamflora",
  wordmark: "REAMFLORA",
  description:
    "Botanical accessories and easy clothing designed in Hong Kong in small, thoughtful editions.",
  shortDescription: "Botanical colour, designed in Hong Kong.",
  contact: {
    customerServiceEmail: "earth@reamflora.buzz",
    wholesaleEmail: "earth@reamflora.buzz",
    address: "311 Sims Harris Rd, Gillsville, GA 30543 US",
    hours: "Monday–Friday, 10:00–18:00 HKT",
  },
  social: {},
  locale: "en-US",
  currency: "USD",
  currencySymbol: "$",
  freeShippingThreshold: null,
  returnsWindowDays: 15,
  defaultShipping: 9.99,
  logo: "/head/reamflora-mark.svg",
};

export const formatPrice = (value) =>
  new Intl.NumberFormat(siteConfig.locale, {
    style: "currency",
    currency: siteConfig.currency,
    minimumFractionDigits: Number(value) % 1 === 0 ? 0 : 2,
  }).format(Number(value));

export default siteConfig;
